export const homedetailOtherRouter = [
  {
    // has: 'orderUpdate',
    path: 'home/home-detail',
    icon: 'social-buffer',
    name: 'homeDetail',
    title: '设备详情',
    meta: {activeName: 'deviceList'},
    component: () => import('@/views/gip/home/home-detail.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/home/homedetail.js